module.exports = __webpack_public_path__ + "static/media/libro2.f1a75cb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/libro2.png
// module id = 205
// module chunks = 0